/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface CardPoolSettingsValidation
 */
export interface CardPoolSettingsValidation {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof CardPoolSettingsValidation
     */
    currency?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof CardPoolSettingsValidation
     */
    cardPoolId?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof CardPoolSettingsValidation
     */
    cardType?: ValidationMessage;
    /**
     * 
     * @type {number}
     * @memberof CardPoolSettingsValidation
     */
    readonly index?: number;
}

export function CardPoolSettingsValidationFromJSON(json: any): CardPoolSettingsValidation {
    return CardPoolSettingsValidationFromJSONTyped(json, false);
}

export function CardPoolSettingsValidationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardPoolSettingsValidation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currency': !exists(json, 'currency') ? undefined : ValidationMessageFromJSON(json['currency']),
        'cardPoolId': !exists(json, 'cardPoolId') ? undefined : ValidationMessageFromJSON(json['cardPoolId']),
        'cardType': !exists(json, 'cardType') ? undefined : ValidationMessageFromJSON(json['cardType']),
        'index': !exists(json, 'index') ? undefined : json['index'],
    };
}

export function CardPoolSettingsValidationToJSON(value?: CardPoolSettingsValidation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'currency': ValidationMessageToJSON(value.currency),
        'cardPoolId': ValidationMessageToJSON(value.cardPoolId),
        'cardType': ValidationMessageToJSON(value.cardType),
    };
}


